import {Skeleton} from "@mui/material";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {sharedSelectors, updateCycleDetails} from "@/redux/slices/admin/shared";
import {useEffect} from "react";
import {cyclesApi, useGetCycleDetailsQuery} from "@/redux/rtk/admin/cycles";
import {CYCLE_PROPS} from "@/app/admin/cycles/page";

const CycleName = ({uid}: { uid: number }) => {
    const {data, isLoading} = useGetCycleDetailsQuery(uid);
    const dispatch= useDispatch();
    const cycleDetails = useSelector(state => sharedSelectors.getCycleDetails(state), shallowEqual);

    useEffect(() => {
        if(data?.data?.cycleDetails?.[0]) {
            dispatch(updateCycleDetails(data.data.cycleDetails[0] as CYCLE_PROPS))
        }
    }, [data])

    useEffect(() => {
        return () => {
            dispatch(cyclesApi.util.resetApiState());
        };
    }, [dispatch]);

    return <>
        {isLoading ? <Skeleton sx={{width: "5rem"}} variant="text"/> :
            !cycleDetails ? null : `${cycleDetails.name}`}
    </>
}

export default CycleName;